import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import queryString from 'query-string';
export class AgeAuthFinishPage extends Component {
  static propTypes = {
    status: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      isKakaoTalkWebView: true
    };
    
    this.titleSuccessStyles = {
      position: 'absolute',
      left: 0,
      bottom: '40.2%',
      width: '100%',
      paddingTop: '145px',
      fontSize: '19px',
      lineHeight: '19px',
      textAlign: 'center',
      letterSpacing: '-1px',
      background: 'url(https://mud-kage.kakao.com/dn/XuYp9/btqcnJZ7VEi/wMA6oye8B7Qa8bY7YwPmr0/img.png) no-repeat center top',
      backgroundSize: '100px 135px'
    };

    this.titleErrorStyles = Object.assign({}, this.titleSuccessStyles, {
      background: 'url(https://mud-kage.kakao.com/dn/96xkJ/btqclOgvGrw/YBebVbxYRPN2EootRKCYk1/img.png) no-repeat center top',
      backgroundSize: '100px 116px'
    });

    this.buttonStyles = {
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100%',
      height: '47px',
      fontSize: '16px',
      color: '#1e1e1e',
      backgroundColor: '#ffe500',
      textAlign: 'center'
    }
  }

  componentDidMount() {
    const uagent = navigator && navigator.userAgent.toLocaleLowerCase();
    this.setState({
      isKakaoTalkWebView: uagent.indexOf('kakaotalk') !== -1
    });
  }

  renderCloseButton() {
    return (
      <a href="account://close" onClick={(ev) => {
        if (!this.state.isKakaoTalkWebView) {
          window.open("","_self").close();
        }
      }}>
        <button type="button" style={this.buttonStyles}>닫기</button>
      </a>
    );
  }

  renderStatus() {
    const {status} = this.props;
    let styleType = this.titleErrorStyles;
    let statusText = '알 수 없는 오류가 발생했습니다.<br />잠시 후 다시 시도해 주십시오.';
    // NOTE: https://wiki.daumkakao.com/pages/viewpage.action?pageId=346240419#id-%EC%9D%B8%EC%A6%9DAPI%EC%97%B0%EB%8F%99%EA%B0%80%EC%9D%B4%EB%93%9C-result
    if (status === 0) {
      styleType = this.titleSuccessStyles;
      statusText = '본인인증이 완료 되었습니다.';
    } else if (status === -440) {
      statusText = '호출 형식이 잘못되었습니다.<br />다시 시도해 주십시오.';
    } else if (status === -401) {
      statusText = '인증되지 않은 사용자 입니다.<br />다시 시도해 주십시오.';
    } else if (status === -450) {
      statusText = '연령인증이 완료되지 않았습니다.<br />다시 시도해 주십시오.';
    } else if (status === -451) {
      statusText = '연령 제한으로 서비스 이용이 불가합니다.';
    } else if (status === -452) {
      statusText = '이미 연령인증이 되었습니다.';
    } else if (status === -453) {
      statusText = '연령인증 횟수가 초과 되었습니다.';
    } else if (status === -480) {
      statusText = '이전 인증 정보와 불일치 합니다.<br />다시 시도해 주십시오.';
    } else if (status === -481) {
      statusText = 'CI 정보가 불일치 합니다.';
    }
    return <p className="txt_confirm" style={styleType} dangerouslySetInnerHTML={{ __html: statusText }}></p>;
  }

  render() {
    return (
      <div id="kakaoContent" className="cont_auth_finish" role="main" key="content">
        <h2 id="kakaoBody" className="screen_out">채널 추가영역</h2>
        <div className="cont_confirm">
          {this.renderStatus()}
          {this.renderCloseButton()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps ) => {
  const { device, phase } = state;
  const { location: { search }} = ownProps;
  const query = queryString.parse(search);
  const status = +((query.status || '0'));
  return { status, device, phase };
};

export default connect(
  mapStateToProps, 
  (dispatch) => bindActionCreators({
  }, dispatch)
)(AgeAuthFinishPage);



// WEBPACK FOOTER //
// ./src/containers/AgeAuthFinishPage/index.js